import dayjs from "dayjs";
import { BACKEND_DATE_FORMAT } from "../../../consts/index.js";

export const safeColor = (fallback, maybe) => (maybe ? maybe : fallback);

export const hexToRgba = (hex, alpha = 1) => {
  if (!hex) return `rgba(0, 0, 0, ${alpha})`;
  const clean = String(hex).replace("#", "");
  const full =
    clean.length === 3
      ? clean
          .split("")
          .map((c) => c + c)
          .join("")
      : clean;
  if (full.length !== 6) return `rgba(0, 0, 0, ${alpha})`;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const isValidBackendDate = (s) => {
  if (!s) return false;
  return dayjs(String(s), BACKEND_DATE_FORMAT, true).isValid();
};

// Detect desktop-ish devices (laptop/desktop).
// If true => we allow native fullscreen.
// If false (mobile/tablet) => always use pseudo fullscreen.
export const isDesktopDevice = () => {
  if (typeof window === "undefined") return true;

  const coarsePointer =
    window.matchMedia?.("(pointer: coarse)")?.matches ?? false; // typical phone/tablet
  const hasTouch =
    "ontouchstart" in window || (navigator?.maxTouchPoints ?? 0) > 0;

  // Heuristic: "desktop" when NOT coarse pointer and NOT touch.
  // This excludes iPad (touch) and most tablets/phones.
  return !coarsePointer && !hasTouch;
};

export const stopHeaderSort = (e) => {
  e.stopPropagation();
};

const NATURAL_COLLATOR =
  typeof Intl !== "undefined" && Intl.Collator
    ? new Intl.Collator(undefined, { numeric: true, sensitivity: "base" })
    : null;

export const naturalCompare = (a, b) => {
  const aa = String(a ?? "");
  const bb = String(b ?? "");
  return NATURAL_COLLATOR
    ? NATURAL_COLLATOR.compare(aa, bb)
    : aa.localeCompare(bb);
};
